module.exports = __webpack_public_path__ + "img/253.f1b271b1.jpg";